<template>
  <div class="carte-boissons">
    <!-- Artwork décoratif (print only) -->
    <img :src="require('@/assets/arts/cabanedj.svg')" class="art art-topleft print-only" alt="" aria-hidden="true">
    <img :src="require('@/assets/arts/lightstop.svg')" class="art art-topleft-lights print-only" alt="" aria-hidden="true">
    <img :src="require('@/assets/arts/boules.svg')" class="art art-bottomleft print-only" alt="" aria-hidden="true">
    <img :src="require('@/assets/arts/lightsbottom.svg')" class="art art-bottomright-lights print-only" alt="" aria-hidden="true">

    <div class="carte-container">

      <!-- HEADER: Logo centré (print only) -->
      <div class="carte-header print-only">
        <img :src="require('@/assets/logotop.svg')" alt="Le Cabanon Annecy" class="logo">
      </div>

      <div class="menu-grid">

        <!-- BIÈRES PRESSION -->
        <div class="category-card color-teal">
          <h2>Bières Pression</h2>
          <table>
            <tr>
              <th></th>
              <th>25Cl</th>
              <th>50Cl</th>
              <th>1,5L</th>
            </tr>
            <tr>
              <td class="item-name"><img :src="require('@/assets/brands/carlsberg.svg')" class="brand-logo brand-wide" alt="Carlsberg">Carlsberg Blonde 5%</td>
              <td class="price-col">4€</td>
              <td class="price-col">8€</td>
              <td class="price-col">20€</td>
            </tr>
            <tr>
              <td class="item-name"><img :src="require('@/assets/brands/brooklyn.svg')" class="brand-logo brand-round" alt="Brooklyn Brewery">Brooklyn Bodega Run IPA 5%</td>
              <td class="price-col">4,5€</td>
              <td class="price-col">9€</td>
              <td class="price-col">25€</td>
            </tr>
            <tr>
              <td class="item-name"><img :src="require('@/assets/brands/labete.png')" class="brand-logo brand-round" alt="La Bête">La Bête Rouge 8%</td>
              <td class="price-col">4,5€</td>
              <td class="price-col">9€</td>
              <td class="price-col">25€</td>
            </tr>
            <tr>
              <td class="item-name"><img :src="require('@/assets/brands/1664.jpg')" class="brand-logo brand-round" alt="1664">1664 Blanche 5%</td>
              <td class="price-col">4,5€</td>
              <td class="price-col">9€</td>
              <td class="price-col">25€</td>
            </tr>
            <tr>
              <td class="item-name">Panaché / Monaco</td>
              <td class="price-col">4€</td>
              <td class="price-col">8€</td>
              <td class="price-col">-</td>
            </tr>
            <tr>
              <td class="item-name">Picon</td>
              <td class="price-col">5€</td>
              <td class="price-col">10€</td>
              <td class="price-col">30€</td>
            </tr>
          </table>
        </div>

        <!-- BOUTEILLES -->
        <div class="category-card color-rose">
          <h2>Bouteilles 33Cl</h2>
          <div class="menu-item"><span class="item-name">Ocho Hard Cider 8%</span><span class="item-dots"></span><span class="item-price">7€</span></div>
          <div class="menu-item"><span class="item-name">Pietra Limoncella 6%</span><span class="item-dots"></span><span class="item-price">6,5€</span></div>
          <div class="menu-item"><span class="item-name">Bière du moment (Salève)</span><span class="item-dots"></span><span class="item-price">Voir ardoise</span></div>
        </div>

        <!-- VINS -->
        <div class="category-card color-amber">
          <h2>Vins au verre 12Cl</h2>
          <div class="menu-item"><span class="item-name">Chardonnay</span><span class="item-dots"></span><span class="item-price">5€</span></div>
          <div class="menu-item"><span class="item-name">Rosé IGP Provence</span><span class="item-dots"></span><span class="item-price">5€</span></div>
          <div class="menu-item"><span class="item-name">Blanc Moelleux</span><span class="item-dots"></span><span class="item-price">6€</span></div>
          <div class="menu-item"><span class="item-name">Symphonie Château Ste Marguerite</span><span class="item-dots"></span><span class="item-price">7€</span></div>
          <div class="menu-item"><span class="item-name">Blanc de Savoie</span><span class="item-dots"></span><span class="item-price">6€</span></div>
          <div class="menu-item"><span class="item-name">Prosecco</span><span class="item-dots"></span><span class="item-price">7€</span></div>
          <div class="menu-item"><span class="item-name">Champagne</span><span class="item-dots"></span><span class="item-price">11€</span></div>
        </div>

        <!-- APERITIFS & LIQUEURS -->
        <div class="category-card color-teal">
          <h2>Apéritif &amp; Liqueurs 4Cl</h2>
          <div class="menu-item"><span class="item-name">Lillet blanc</span><span class="item-dots"></span><span class="item-price">6€</span></div>
          <div class="menu-item"><span class="item-name">Suze</span><span class="item-dots"></span><span class="item-price">6€</span></div>
          <div class="menu-item"><span class="item-name">Get 27</span><span class="item-dots"></span><span class="item-price">6€</span></div>
          <div class="menu-item"><span class="item-name">Limoncello</span><span class="item-dots"></span><span class="item-price">6€</span></div>
          <div class="menu-item"><span class="item-name">Bailey's</span><span class="item-dots"></span><span class="item-price">6€</span></div>
        </div>

        <!-- SHOT -->
        <div class="shot-badge">
          SHOT · 4€
        </div>

        <!-- SANS ALCOOL -->
        <div class="category-card color-amber">
          <h2>Sans alcool</h2>
          <div class="menu-item"><span class="item-name">Tourtel Twist Citron 0,0% 27,5Cl</span><span class="item-dots"></span><span class="item-price">5,5€</span></div>
          <div class="menu-item"><span class="item-name">Brooklyn Zéro Effect 0,4%</span><span class="item-dots"></span><span class="item-price">6,5€</span></div>
          <div class="menu-item"><span class="item-name">Mojito / Ugo Zero 0,0% 25Cl</span><span class="item-dots"></span><span class="item-price">6€</span></div>
          <div class="menu-item"><span class="item-name">El Tony Mate 33Cl</span><span class="item-dots"></span><span class="item-price">5€</span></div>
        </div>

        <!-- COCKTAILS -->
        <div class="category-card color-rose">
          <h2>Cocktails</h2>
          <div class="menu-item"><span class="item-name">Suzito</span><span class="item-dots"></span><span class="item-price">8,5€</span></div>
          <div class="menu-item"><span class="item-name">Mojito Lillet</span><span class="item-dots"></span><span class="item-price">8,5€</span></div>
          <div class="menu-item"><span class="item-name">Mojito Passion</span><span class="item-dots"></span><span class="item-price">9€</span></div>
          <div class="menu-item"><span class="item-name">Passion Mule</span><span class="item-dots"></span><span class="item-price">9€</span></div>
          <div class="menu-item"><span class="item-name">Aperol Spritz</span><span class="item-dots"></span><span class="item-price">8,5€</span></div>
          <div class="menu-item"><span class="item-name">Ugo Spritz</span><span class="item-dots"></span><span class="item-price">9€</span></div>
          <div class="menu-item"><span class="item-name">Limoncello Spritz</span><span class="item-dots"></span><span class="item-price">9€</span></div>
          <div class="menu-item"><span class="item-name">Sarti Rosa Spritz</span><span class="item-dots"></span><span class="item-price">9€</span></div>
          <div class="menu-item"><span class="item-name">Apéro Bull</span><span class="item-dots"></span><span class="item-price">9€</span></div>
          <span class="item-desc">Aperol 4 cl + Red Bull 25 cl</span>
          <div class="menu-item"><span class="item-name">Pinky Peach</span><span class="item-dots"></span><span class="item-price">9€</span></div>
          <span class="item-desc">Sarti 4 cl + Red Bull Pêche Blanche 25 cl</span>
        </div>

        <!-- BOISSONS FRAICHES -->
        <div class="category-card color-teal">
          <h2>Boissons Fraîches</h2>
          <div class="menu-item"><span class="item-name">Eau minérale (50Cl)</span><span class="item-dots"></span><span class="item-price">3€</span></div>
          <div class="menu-item"><span class="item-name">Sirop à l'eau</span><span class="item-dots"></span><span class="item-price">2,5€</span></div>
          <div class="menu-item"><span class="item-name"><img :src="require('@/assets/brands/cocacola.svg')" class="brand-logo brand-wide" alt="Coca-Cola">Classic, Sans Sucres, Cherry (33Cl)</span><span class="item-dots"></span><span class="item-price">3,5€</span></div>
          <div class="menu-item"><span class="item-name"><img :src="require('@/assets/brands/fuzetea.svg')" class="brand-logo brand-wide" alt="Fuzetea">(33Cl)</span><span class="item-dots"></span><span class="item-price">3,5€</span></div>
          <div class="menu-item"><span class="item-name"><img :src="require('@/assets/brands/sprite.svg')" class="brand-logo brand-wide" alt="Sprite">(33Cl)</span><span class="item-dots"></span><span class="item-price">3,5€</span></div>
          <div class="menu-item"><span class="item-name">Arbre Jus (25Cl)</span><span class="item-dots"></span><span class="item-price">4,5€</span></div>
          <span class="item-desc">Tomate, pomme, abricot</span>
          <div class="menu-item"><span class="item-name">Jus d'orange pressé</span><span class="item-dots"></span><span class="item-price">5,5€</span></div>
          <div class="menu-item"><span class="item-name">Citron Pressé</span><span class="item-dots"></span><span class="item-price">4,5€</span></div>
          <div class="menu-item"><span class="item-name">Thé glacé MAISON</span><span class="item-dots"></span><span class="item-price">4€</span></div>
          <div class="menu-item"><span class="item-name">Red Bull Classic, Sugarfree, Edition (25Cl)</span><span class="item-dots"></span><span class="item-price">5€</span></div>
        </div>

        <!-- CAFÉTERIES -->
        <div class="category-card color-rose">
          <h2>Caféteries</h2>
          <div class="menu-item"><span class="item-name">Espresso / Ristretto / Allongé</span><span class="item-dots"></span><span class="item-price">2€</span></div>
          <div class="menu-item"><span class="item-name">Noisette / Café au lait / Décaféiné</span><span class="item-dots"></span><span class="item-price">2,5€</span></div>
          <div class="menu-item"><span class="item-name">Double Espresso</span><span class="item-dots"></span><span class="item-price">3,5€</span></div>
          <div class="menu-item"><span class="item-name">Chocolat / Cappucino / Latte</span><span class="item-dots"></span><span class="item-price">4€</span></div>
          <div class="menu-item"><span class="item-name">Flat White / Latte Macchiato</span><span class="item-dots"></span><span class="item-price">4,5€</span></div>
          <div class="menu-item"><span class="item-name">Chai Latte / Matcha Coco</span><span class="item-dots"></span><span class="item-price">4,5€</span></div>
          <div class="menu-item"><span class="item-name">Thé Kusmi Tea</span><span class="item-dots"></span><span class="item-price">3€</span></div>
          <div class="menu-item"><span class="item-name">Café Frappé</span><span class="item-dots"></span><span class="item-price">5€</span></div>
          <div class="menu-item"><span class="item-name">Supp lait végétal avoine</span><span class="item-dots"></span><span class="item-price">+1€</span></div>

        </div>

      </div>

      <!-- FORMULES P'TIT DÈJ — côte à côte -->
      <div class="formules-row">
        <div class="category-card color-teal formule-card">
          <h2>Formule P'tit Dèj Classique</h2>
          <div class="formule-price">8,5€</div>
          <span class="item-desc">Viennoiserie, orange pressée, boisson chaude (espresso, ristretto, thé, allongé, café au lait)</span>
        </div>

        <div class="category-card color-amber formule-card">
          <h2>Formule P'tit Dèj Latte</h2>
          <div class="formule-price">9,5€</div>
          <span class="item-desc">Viennoiserie, orange pressée, boisson chaude (cappuccino, chocolat, grand crème, latte)</span>
        </div>
      </div>

      <!-- ECOCUP -->
      <div class="footer-note">
        CONSIGNE ÉCOCUP<br><span class="footer-detail">Verre 1€ · Pichet 5€</span>
      </div>

      <!-- INSTAGRAM -->
      <div class="insta-container">
        <a href="https://www.instagram.com/lecabanon.annecy/" target="_blank" rel="noopener noreferrer" class="insta-link">
          <svg class="insta-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 157.1 25.8">
            <path fill="#0c0c0b" d="M21.2,6c0,.9-.7,1.5-1.5,1.5s-1.5-.7-1.5-1.5.7-1.5,1.5-1.5,1.5.7,1.5,1.5M12.8,17.1c-2.4,0-4.3-1.9-4.3-4.3s1.9-4.3,4.3-4.3,4.3,1.9,4.3,4.3-1.9,4.3-4.3,4.3M12.8,6.2c-3.6,0-6.6,2.9-6.6,6.6s2.9,6.6,6.6,6.6,6.6-3,6.6-6.6-3-6.6-6.6-6.6M12.8,0C9.3,0,8.9,0,7.5,0c-1.4,0-2.3.3-3.1.6-.8.3-1.6.8-2.3,1.5-.7.7-1.2,1.4-1.5,2.3-.3.8-.5,1.7-.6,3.1C0,8.9,0,9.3,0,12.8s0,3.9,0,5.3c0,1.4.3,2.3.6,3.1.3.8.8,1.6,1.5,2.3.7.7,1.4,1.2,2.3,1.5.8.3,1.7.5,3.1.6,1.4,0,1.8,0,5.3,0s3.9,0,5.3,0c1.4,0,2.3-.3,3.1-.6.8-.3,1.6-.8,2.3-1.5.7-.7,1.2-1.4,1.5-2.3.3-.8.5-1.7.6-3.1,0-1.4,0-1.8,0-5.3s0-3.9,0-5.3c0-1.4-.3-2.3-.6-3.1-.3-.8-.8-1.6-1.5-2.3-.7-.7-1.4-1.2-2.3-1.5-.8-.3-1.7-.5-3.1-.6C16.8,0,16.3,0,12.8,0M12.8,2.3c3.4,0,3.8,0,5.2,0,1.3,0,1.9.3,2.4.4.6.2,1,.5,1.5,1,.4.4.7.9,1,1.5.2.5.4,1.1.4,2.4,0,1.4,0,1.8,0,5.2s0,3.8,0,5.2c0,1.3-.3,1.9-.4,2.4-.2.6-.5,1-1,1.5-.4.4-.9.7-1.5,1-.5.2-1.1.4-2.4.4-1.4,0-1.8,0-5.2,0s-3.8,0-5.2,0c-1.3,0-1.9-.3-2.4-.4-.6-.2-1-.5-1.5-1-.4-.4-.7-.9-1-1.5-.2-.5-.4-1.1-.4-2.4,0-1.4,0-1.8,0-5.2s0-3.8,0-5.2c0-1.3.3-1.9.4-2.4.2-.6.5-1,1-1.5.4-.4.9-.7,1.5-1,.5-.2,1.1-.4,2.4-.4,1.4,0,1.8,0,5.2,0"/>
            <text fill="#231f20" font-family="Montserrat, sans-serif" font-style="italic" font-size="9" x="29.1" y="11.2">Planning &amp; événements</text>
            <text fill="#231f20" font-family="Montserrat, sans-serif" font-weight="700" font-size="10" x="29.1" y="23.2">@lecabanon.annecy</text>
          </svg>
        </a>
      </div>

      <!-- BOUTONS -->
      <div class="pdf-container no-print">
        <router-link to="/" class="btn-back">← Retour à l'accueil</router-link>
        <a href="/carte-boissons.pdf" download="carte-cabanon.pdf" class="btn-pdf">Télécharger la carte</a>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'CarteBoissons'
}
</script>

<style scoped>
.carte-boissons {
  background-color: #eded87;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  padding: 40px 20px;
}

/* Artworks décoratifs */
.art {
  position: absolute;
  pointer-events: none;
  z-index: 0;
}
.art-topleft {
  left: -100px;
  top: -100px;
  width: 1100px;
  opacity: 1;
}
.art-topleft-lights {
  right: -80px;
  top: -120px;
  width: 280px;
  opacity: 1;
}
.art-bottomright-lights {
  right: -50px;
  bottom: -120px;
  width: 280px;
  opacity: 1;
}
.art-bottomleft {
  left: -40px;
  bottom: -40px;
  width: 350px;
  opacity: 1;
  transform: scaleX(-1);
}

.carte-container {
  max-width: 900px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

/* Print only */
.print-only {
  display: none;
}

/* Header: logo centré */
.carte-header {
  text-align: center;
  margin-bottom: 30px;
}
.logo {
  max-width: 450px;
  height: auto;
  filter: drop-shadow(0 4px 6px rgba(0,0,0,0.15));
}

/* Instagram en bas */
.insta-container {
  text-align: center;
  margin-top: 20px;
}
.insta-logo {
  width: 160px;
  height: auto;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.15));
  transition: transform 0.2s ease;
}
.insta-logo:hover {
  transform: scale(1.05);
}

/* Grille menu */
.menu-grid {
  column-count: 2;
  column-gap: 24px;
}

/* Catégorie */
.category-card {
  break-inside: avoid-column;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 14px;
  padding: 16px;
  margin-bottom: 20px;
}

.category-card h2 {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.3em;
  font-weight: 800;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-top: 0;
  margin-bottom: 12px;
  padding-bottom: 8px;
}

/* Couleurs par catégorie */
.color-teal { border: 2.5px solid #44bfb1; box-shadow: 0 3px 10px rgba(68,191,177,0.15); }
.color-teal h2 { color: #44bfb1; border-bottom: 2px dashed #44bfb1; }
.color-teal .item-price, .color-teal .price-col { color: #44bfb1; }
.color-teal .item-dots { border-bottom-color: #44bfb1; }

.color-rose { border: 2.5px solid #f387a2; box-shadow: 0 3px 10px rgba(243,135,162,0.15); }
.color-rose h2 { color: #f387a2; border-bottom: 2px dashed #f387a2; }
.color-rose .item-price, .color-rose .price-col { color: #f387a2; }
.color-rose .item-dots { border-bottom-color: #f387a2; }

.color-amber { border: 2.5px solid #3c7397; box-shadow: 0 3px 10px rgba(60,115,151,0.15); }
.color-amber h2 { color: #3c7397; border-bottom: 2px dashed #3c7397; }
.color-amber .item-price, .color-amber .price-col { color: #3c7397; }
.color-amber .item-dots { border-bottom-color: #3c7397; }

/* Items menu */
.menu-item {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 6px;
  font-size: 0.9em;
}

.menu-item .item-name {
  font-weight: 700;
  text-transform: capitalize;
  color: #1b3345;
}

.item-dots {
  flex-grow: 1;
  border-bottom: 2px dotted;
  margin: 0 8px;
  opacity: 0.5;
}

/* Logos de marques */
.brand-logo {
  width: auto;
  vertical-align: -0.25em;
  margin-right: 5px;
  display: inline-block;
}
.brand-wide {
  height: 1.15em;
}
.brand-round {
  height: 1.4em;
  vertical-align: -0.4em;
}

.item-price {
  font-weight: 700;
  white-space: nowrap;
}

.item-desc {
  display: block;
  font-size: 0.75em;
  font-style: italic;
  color: #555;
  margin-top: -4px;
  margin-bottom: 6px;
  line-height: 1.3;
}

/* Tables */
table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85em;
  margin-bottom: 4px;
}

th {
  text-align: right;
  font-weight: normal;
  font-style: italic;
  padding-bottom: 6px;
  color: #666;
}

td {
  padding: 4px 0;
}

td.item-name {
  font-weight: 700;
  color: #1b3345;
  white-space: nowrap;
}

td.price-col {
  text-align: right;
  font-weight: 700;
  width: 12%;
}

td.voir-ardoise {
  text-align: right;
  font-style: italic;
  font-size: 0.9em;
  padding-top: 5px;
  color: #666;
}

.separator {
  border-top: 1px dashed #1b3345;
  margin: 10px 0;
  padding-top: 10px;
}

/* Badge shot */
.shot-badge {
  break-inside: avoid-column;
  text-align: center;
  background-color: #44bfb1;
  color: #fff;
  border: 2.5px solid #44bfb1;
  padding: 12px 16px;
  border-radius: 14px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 1.1em;
  letter-spacing: 3px;
  margin-top: 30px;
  margin-bottom: 20px;
  box-shadow: 0 3px 10px rgba(68,191,177,0.15);
  transform: rotate(-2deg);
}

.formules-row {
  display: flex;
  gap: 24px;
  margin-top: 20px;
}
.formules-row .formule-card {
  flex: 1;
}
.formule-card {
  text-align: center;
}
.formule-card h2 {
  font-size: 1.1em;
}
.formule-price {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.3em;
  font-weight: 900;
  color: #1b3345;
  margin-bottom: 6px;
}
.formule-card .item-desc {
  text-align: center;
}

/* Footer écocup */
.footer-note {
  text-align: center;
  background-color: #1b3345;
  color: #eded87;
  padding: 12px 20px;
  border-radius: 14px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 1em;
  letter-spacing: 3px;
  margin-top: 20px;
  box-shadow: 0 3px 10px rgba(27,51,69,0.3);
}
.footer-detail {
  font-weight: 600;
  font-size: 0.85em;
  letter-spacing: 1px;
}

/* Boutons */
.pdf-container {
  text-align: center;
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
}
.btn-pdf,
.btn-back {
  display: inline-block;
  background-color: #1b3345;
  color: #eded87 !important;
  border: none;
  border-radius: 14px;
  padding: 12px 30px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 1em;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  transition: background-color 0.3s;
  text-decoration: none !important;
}
.btn-back {
  background-color: transparent;
  color: #1b3345 !important;
  border: 2px solid #1b3345;
}
.btn-pdf:hover {
  background-color: #2a4d66;
}
.btn-back:hover {
  background-color: #1b3345;
  color: #eded87 !important;
}

/* Mode export PDF */
.export-mode {
  width: 297mm;
  height: 420mm;
  max-height: 420mm;
  overflow: hidden;
  padding: 15mm 12mm;
  box-sizing: border-box;
}
.export-mode .print-only {
  display: block !important;
}
.export-mode .no-print {
  display: none !important;
}
.export-mode .carte-container {
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.export-mode .menu-grid {
  column-count: 2;
  column-gap: 24px;
  flex: 1;
}
.export-mode .category-card,
.export-mode .color-teal,
.export-mode .color-rose,
.export-mode .color-amber {
  box-shadow: none;
}
.export-mode .footer-note {
  box-shadow: none;
}
.export-mode .art {
  display: block !important;
}
.export-mode .carte-header {
  margin-bottom: 16px;
}
.export-mode .logo {
  max-width: 380px;
}
.export-mode .insta-logo {
  width: 180px;
}
.export-mode .insta-container {
  margin-top: 12px;
}
.export-mode .formules-row {
  display: flex;
  gap: 24px;
  margin-top: 12px;
}
.export-mode .formules-row .formule-card {
  flex: 1;
}
.export-mode .shot-badge {
  box-shadow: none;
}

/* Responsive */
@media (max-width: 768px) {
  .menu-grid {
    column-count: 1;
  }
  table {
    font-size: 0.8em;
  }
  .logo {
    max-width: 280px;
  }
  .insta-logo {
    width: 100px;
  }
  .formules-row {
    flex-direction: column;
  }
}

/* Print A3 */
@media print {
  @page {
    size: A3 portrait;
    margin: 0;
  }

  /* Cacher tout sauf la carte */
  .no-print {
    display: none !important;
  }

  .carte-boissons {
    width: 297mm;
    height: 420mm;
    max-height: 420mm;
    overflow: hidden !important;
    padding: 15mm 12mm;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    box-sizing: border-box;
  }

  .art {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .carte-container {
    max-width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .category-card,
  .color-teal,
  .color-rose,
  .color-amber {
    box-shadow: none !important;
  }

  .menu-grid {
    column-count: 2;
    column-gap: 24px;
    flex: 1;
  }

  .category-card {
    padding: 9px 11px;
    margin-bottom: 8px;
  }

  .category-card h2 {
    font-size: 1.2em;
    margin-bottom: 6px;
    padding-bottom: 5px;
  }

  .menu-item {
    font-size: 0.92em;
    margin-bottom: 2px;
  }

  table {
    font-size: 0.88em;
  }

  .item-desc {
    font-size: 0.78em;
  }

  .footer-note {
    margin-top: 12px;
    padding: 8px;
    font-size: 1em;
    box-shadow: none;
  }

  .logo {
    max-width: 380px;
  }

  .insta-logo {
    width: 180px;
  }

  .print-only {
    display: block !important;
  }

  .carte-header {
    margin-bottom: 16px;
  }

  .insta-container {
    margin-top: 12px;
  }

  .formules-row {
    display: flex !important;
    flex-direction: row !important;
    gap: 16px;
    margin-top: 8px;
    width: 100%;
  }
  .formules-row .formule-card {
    flex: 1;
    padding: 10px;
    margin-bottom: 8px;
  }
  .formule-price {
    font-size: 1.1em !important;
  }
  .shot-badge {
    box-shadow: none !important;
    margin-top: 16px;
    padding: 8px 12px;
    font-size: 0.85em;
  }
  .footer-note {
    margin-top: 8px !important;
    padding: 6px !important;
    font-size: 0.9em !important;
  }
  .footer-detail {
    font-size: 0.8em;
  }
}
</style>
